var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_not_found"},[_c('h2',[_vm._v("404 - THE PAGE CAN'T BE FOUND")]),_c('a',{on:{"click":function($event){return _vm.$router.push('dashboard')}}},[_vm._v("Go TO Home")])])}
var staticRenderFns = []

export { render, staticRenderFns }